module.exports = __webpack_public_path__ + "img/annotationNews.d05e26fd.svg";